// Dictionaries for English and Turkish languages
import enMessages from '../common/localization/en.json'
import trMessages from '../common/localization/tr.json'
import { locale, loadMessages } from 'devextreme/localization'

const devExtremeLocalization = (value) => {
  loadMessages(enMessages)
  loadMessages(trMessages)
  locale(value)
}

export default devExtremeLocalization
